import { Array as RunTypesArray, Boolean, Literal, Optional, Record, String, Union } from "runtypes";
import { Reason } from "../../../types/error";
import { RevocationStatus, RevocationStatusArray, ValidRevocationStatus, ValidRevocationStatusArray, } from "../revocation.types";
/**
 * Document store issuance status
 */
export const ValidDocumentStoreIssuanceStatus = Record({
    issued: Literal(true),
    address: String,
});
export const ValidDocumentStoreIssuanceStatusArray = RunTypesArray(ValidDocumentStoreIssuanceStatus);
export const InvalidDocumentStoreIssuanceStatus = Record({
    issued: Literal(false),
    address: String,
    reason: Reason,
});
export const DocumentStoreIssuanceStatus = Union(ValidDocumentStoreIssuanceStatus, InvalidDocumentStoreIssuanceStatus);
export const DocumentStoreIssuanceStatusArray = RunTypesArray(DocumentStoreIssuanceStatus);
/**
 * Data for v2 Fragments
 */
const ValidDocumentStoreDataV2 = Record({
    issuedOnAll: Literal(true),
    revokedOnAny: Literal(false),
    details: Record({
        issuance: ValidDocumentStoreIssuanceStatusArray,
        revocation: ValidRevocationStatusArray,
    }),
});
export const InvalidDocumentStoreDataV2 = Record({
    issuedOnAll: Boolean,
    revokedOnAny: Optional(Boolean),
    details: Record({
        issuance: DocumentStoreIssuanceStatusArray,
        revocation: Optional(RevocationStatusArray),
    }),
});
/**
 * Data for v3 Fragments
 */
export const ValidDocumentStoreDataV3 = Record({
    issuedOnAll: Literal(true),
    revokedOnAny: Literal(false),
    details: Record({
        issuance: ValidDocumentStoreIssuanceStatus,
        revocation: ValidRevocationStatus,
    }),
});
export const InvalidDocumentStoreDataV3 = Record({
    issuedOnAll: Boolean,
    revokedOnAny: Boolean,
    details: Record({
        issuance: DocumentStoreIssuanceStatus,
        revocation: RevocationStatus,
    }),
});
